import useSWR, { useSWRConfig } from 'swr'

const useFetch = (axiosInstance, url = '', ...axiosParams) => {
  const { cache } = useSWRConfig()

  const { data, error, mutate, isValidating } = useSWR(url, async path => {
    const response = await axiosInstance.get(path, ...axiosParams)
    return response.data
  }, {
    revalidateOnFocus: false
  })

  return { cache, data, error, mutate, isValidating }
}

export default useFetch
